import { render, staticRenderFns } from "./NeedsMealsTab.vue?vue&type=template&id=2d0b7047&scoped=true&lang=pug"
import script from "./NeedsMealsTab.vue?vue&type=script&lang=ts"
export * from "./NeedsMealsTab.vue?vue&type=script&lang=ts"
import style0 from "./NeedsMealsTab.vue?vue&type=style&index=0&id=2d0b7047&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0b7047",
  null
  
)

export default component.exports